import React from "react";
import FaIcon from "../Elements/FaIcon";
import FieldTypesEnum from "../Enums/FieldTypesEnum";
import TabListTableCellWidthEnum from "../Enums/TabListTableCellWidthEnum";
import dateTimeHelper from "../Helpers/datetimeHelper";

export default class ImportShopItem {
  constructor(item) {
    if (item === undefined) {
      this.ImportShopId = "";
      this.SurveyId = "";
      this.FormId = "";
      this.FormName = "";
      this.UpDatedAt = "";
      this.FormVersion = "";
      this.UserName = "";
      this.SubmissionId = "";
      this.UserLocId = "";
      this.ReportDate = "";
      this.FileName = "";
      this.Status = "";
      this.Questions = "";
      this.ApolloJobId = "";
      this.ErrorDescription = "";
      this.CreatedOn = "";
      this.ImportedOn = "";
      this.SftpDataServerName = "";
      this.History = "";
    } else {
      this.initialize(item);
    }
  }

  async initialize(item) {
    this.ImportShopId = item.importShopId;
    this.SurveyId = item.surveyId;
    this.FormId = item.formId;
    this.FormName = item.formName;
    this.UpDatedAt = item.upDatedAt;
    this.FormVersion = item.formVersion;
    this.UserName = item.userName;
    this.SubmissionId = item.submissionId;
    this.UserLocId = item.userLocId;
    this.ReportDate = item.reportDate;
    this.FileName = item.fileName;
    this.Status = item.status;
    this.Questions = item.questions.replaceAll(",", ", ");
    this.ApolloJobId = item.apolloJobId;
    this.ErrorDescription = item.errorDescription;
    this.CreatedOn = item.createdOn;
    this.ImportedOn = item.importedOn;
    this.SftpDataServerName = item.sftpDataServerName;
    this.History = item.history;
  }

  static NameOfTheIdField() {
    return "ImportShopId";
  }
  static nameOfTheItemDetailList() {
    return "ImportShop";
  }

  static MoneyFields = [];

  static Currency() {
    return "";
  }

  static MoneyFieldsSecondary = [];

  static CurrencySecondary() {
    return "";
  }

  static DateFields = ["ReportDate", "UpDatedAt"];

  static BoolFields = [""];

  static FieldsToShowInListTable = [
    {
      tabName: "Info",
      tabLabel: "Info",
      icon: "fa-solid fa-info",
      data: [
        { name: "ImportShopId", label: "ImportShopId" },
        { name: "SurveyId", label: "Survey Id" },
        { name: "FormId", label: "FormId" },
        { name: "FormName", label: "FormName" },
        { name: "UpDatedAt", label: "UpDatedAt" },
        { name: "UserName", label: "UserName" },
        { name: "UserLocId", label: "UserLocId" },
        { name: "Status", label: "Status" },
        { name: "ApolloJobId", label: "Apollo or Caspian JobId" },
        { name: "CreatedOn", label: "CreatedOn" },
        { name: "ImportedOn", label: "ImportedOn" },
        { name: "SftpDataServerName", label: "SftpDataServerName" },
        { name: "SubmissionId", label: "SubmissionId", width: TabListTableCellWidthEnum.Full },
        { name: "FileName", label: "FileName", width: TabListTableCellWidthEnum.Full },
      ],
    },
    {
      tabName: "Questions",
      tabLabel: "Questions",
      icon: "fa-solid fa-users",
      data: [{ name: ImportShopItem.GetQuestionCellContent, label: "Questions", width: TabListTableCellWidthEnum.TwoLines, className: "text-left" }],
    },
    {
      tabName: "Error",
      tabLabel: "Error",
      icon: "fa-solid fa-exclamation-triangle",
      data: [{ name: "ErrorDescription", label: "ErrorDescription", width: TabListTableCellWidthEnum.TwoLines, className: "text-left" }],
    },
    {
      tabName: "History",
      tabLabel: "History",
      icon: "fa-solid fa-clipboard",
      data: [{ name: ImportShopItem.GetHstoryCellContent, label: "History", width: TabListTableCellWidthEnum.TwoLines, className: "text-left" }],
    },
  ];

  //Meaning of data field:
  //   if type is FieldTypesEnum.DataFieldWithDetails then it is the name of the ID field
  //   if type is FieldTypesEnum.PureDataField then it is the name of the field to show or it is a function
  //			and the field shows the result of this function
  //   if type is FieldTypesEnum.FunctionField then it is the function which will be called by clicking on the labeltext in the cell.
  static FieldsToShowInDataTable() {
    return [
      { label: "ImportShop Id", orderById: "ImportShopId", data: "ImportShopId", type: FieldTypesEnum.DataFieldWithDetails, minWidth: 50 },
      { label: "Survey Id", orderById: "SurveyId", data: "SurveyId", className: "text-center", minWidth: 50 },
      // {label: "Form Id", orderById: "FormId", data:"FormId",className: "text-center",minWidth:50},
      { label: "Form Name", orderById: "FormName", data: "FormName", className: "text-center", minWidth: 50 },
      { label: "Submission Id", orderById: "SubmissionId", data: "SubmissionId", type: FieldTypesEnum.Email, className: "text-center", minWidth: 50 },
      { label: "User LocId", orderById: "UserLocId", data: "UserLocId", className: "text-center", minWidth: 50 },
      { label: "Created On", orderById: "CreatedOn", data: (item) => dateTimeHelper.toYYYYsMMsDDsHHsMMsSS(item.CreatedOn), className: "text-center" },
      // {label: "Imported On", orderById: "ImportedOn", data:(item)=>dateTimeHelper.toYYYYsMMsDDsHHsMMsSS(item.ImportedOn),className:"text-center"},
      { label: "Status", orderById: "Status", data: "Status", className: "text-center" },
      { label: "Apollo or Caspian JobId", orderById: "ApolloJobId", data: "ApolloJobId", className: "text-center" },
    ];
  }

  static GetQuestionCellContent(item) {
    return (
      <textarea className="w-100" rows={5}>
        {item.Questions}
      </textarea>
    );
  }

  static GetHstoryCellContent(item) {
    return (
      <div className="w-100" rows={5}>
        {item.History.map((h) => (
          <p>{h}</p>
        ))}
      </div>
    );
  }

  static getActionsContent(item) {
    return (
      <div>
        <FaIcon iconName="fa-solid fa-edit" className="pointer link" tooltipText="Edit" onClick={() => ImportShopItem.editFunction(item.AddressId, item)} />
      </div>
    );
  }
}
